import { withCompInfo } from '@wix/editor-elements-integrations'
import { getImageMaskCSSVars } from '../WPhoto/WPhoto.mapper'
import type { ImageXDefinition, ImagexCSS } from './ImageX'

export const css = withCompInfo<ImagexCSS, ImageXDefinition>()(['compData'], ({ compData }) => {
	const svgId = compData.mask?.svgId
	return svgId
		? getImageMaskCSSVars({
				svgId,
				x: 0,
				y: 0,
				width: 100,
				height: 100,
				mode: 'alpha',
				flip: 'none',
				rotate: 0,
		  })
		: {}
})
